import React from 'react';
import './Services.css';
import planing_AA from '../assets/1AA.png';
import { Link } from 'react-router-dom';
import about_top_nav_2 from '../assets/about_top_nav_2.jpg';
import Logo from '../assets/PNG_Logo.png';
import {
  FaDraftingCompass,
  FaProjectDiagram,
  FaPlug,
  FaTools,
  FaHome,
  FaCouch,
  FaLightbulb,
  FaRulerCombined,
  FaCogs,
  FaCubes,
  FaBolt
} from 'react-icons/fa';

const services = [
  { icon: <FaDraftingCompass />, label: '2D Planning', sub: '& Details' },
  { icon: <FaProjectDiagram />, label: 'Structural', sub: 'Drawings' },
  { icon: <FaPlug />, label: 'Electrical', sub: 'Drawings' },
  { icon: <FaTools />, label: 'Mechanical', sub: '& Plumbing' },
  { icon: <FaHome />, label: 'Exterior design', sub: '& Visualisation' },
  { icon: <FaCouch />, label: 'Interior design', sub: '& Visualisation' },
];

const servicecards = [
  {
    title: 'Planning',
    image: planing_AA,
    description: 'We provide 2D floor planning and architectural detailing.',
    icon: <FaRulerCombined />,
    link: '/services/planning'
  },
  {
    title: 'Structural Drawing',
    image: '/images/structural.jpg',
    description: 'Load calculations, beam and column placements, etc.',
    icon: <FaDraftingCompass />,
    link: '/services/structural'
  },
  {
    title: '3D Elevation Drawings',
    image: '/images/elevation.jpg',
    description: 'Photo-realistic 3D renderings of exterior designs.',
    icon: <FaCubes />,
    link: '/services/elevation'
  },
  {
    title: 'Electrical Drawing',
    image: '/images/electrical.jpg',
    description: 'Complete electrical layout for safe installations.',
    icon: <FaBolt />,
    link: '/services/electrical'
  },
  {
    title: 'Interior Designs',
    image: '/images/interior.jpg',
    description: 'Elegant and functional interior layouts and visuals.',
    icon: <FaCouch />,
    link: '/services/interior'
  },
  {
    title: 'MEP Drawing',
    image: '/images/mep.jpg',
    description: 'Mechanical, Electrical, Plumbing layout drawings.',
    icon: <FaTools />,
    link: '/services/mep'
  },
  {
    title: 'Interior Designs',
    image: '/images/interior.jpg',
    description: 'Elegant and functional interior layouts and visuals.',
    icon: <FaCouch />,
    link: '/services/interior-2'
  },
  {
    title: 'MEP Drawing',
    image: '/images/mep.jpg',
    description: 'Mechanical, Electrical, Plumbing layout drawings.',
    icon: <FaTools />,
    link: '/services/mep-2'
  }
];

const Services = () => {
  return (
    <div>
    <div className="about_4">
              <div className="about_head_image">
                <img src={about_top_nav_2} alt="" />
                <h1 className="text-white">About Us</h1>
                <div className="overlay-text-5">
                  <div className="head_top_box-1">
                    <img src={Logo} alt="Logo" />
                    <div className="head_top_box">
                      <p className="text-white fs-5">
                        Building Tomorrow's Infrastructure Today
                      </p>
                    </div>
                  </div>
      
                  <div className="head_top_box-2">
                    <h1>Our Services</h1>
                    <div className="services-container">
                      {services.map((service, index) => (
                        <div key={index} className="service-box">
                          <div className="service-icon">{service.icon}</div>
                          <p className="service-text">
                            {service.label}
                            <br />
                            {service.sub}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

    <div className="service-grid">
  {servicecards.map((service, index) => (
    <Link to={service.link} key={index} className="service-card-link">
      <div className="service-card">
        <div className="service-image-wrapper">
          <img src={service.image} alt={service.title} />
          <div className="overlay">
            <p>{service.description}</p>
          </div>
        </div>
        <div className="service-card-footer">
          <div className="service-card-icon">{service.icon}</div>
          <h3>{service.title}</h3>
        </div>
      </div>
    </Link>
  ))}
</div>
    </div>
  );
};

export default Services;
